export default __webpack_public_path__ + "static/media/mobile-generarOrden.f2db5f10.svg";